import { Text } from 'react-native-paper'
import { StyleProp, TextStyle } from 'react-native'

export const LastUsedTag = ({
  show,
  text,
  style,
}: {
  show: boolean
  text: string
  style?: StyleProp<TextStyle>
}) => {
  if (!show) {
    return null
  }

  return (
    <Text variant="labelSmall" style={style}>
      {text}
    </Text>
  )
}
